module.exports = __webpack_public_path__ + "a046592bac8f2fd96e994733faf3858c.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-css/themes/default/assets/fonts/brand-icons.woff
// module id = 259
// module chunks = 4